import { useQuery } from "react-query";

import { fetchSdlDataJson, fetchSdlDataJsonUrl } from "../../../services";

const useGetSdlJson = (listView: string) => {
  return useQuery("json", async () => {
    const url = await fetchSdlDataJsonUrl(listView);
    const selectedUrl =
      url.data.items.edges[0].node.variants.edges[0].node.path;
    const json = await fetchSdlDataJson(selectedUrl);
    return json;
  });
};
export default useGetSdlJson;
